/**
 * `weather` — and, when the graph knew it, the line about the fountains.
 *
 * That line is the one thing a visitor plans the end of their day around, so it
 * gets its own row rather than being folded into the summary.
 *
 * `actions` (§11.4/§11.5: «Что посмотреть в такую погоду» / «Погода на
 * завтра») ride through the shared `CardActions`. No `highlight`/rows here —
 * there is no table to select rows in.
 */

import type { WeatherCardProps } from '../generated/schemas';
import CardActions from './CardActions';
import { stripEmoji as plain } from '../../lib/emoji';

export default function WeatherCard({ props }: { props: WeatherCardProps }) {
  return (
    <article className="card card--weather">
      <header className="card__head">
        <h3 className="card__title">Погода</h3>
        {props.date_label ? <span className="card__meta">{plain(props.date_label)}</span> : null}
      </header>
      <div className="weather">
        {typeof props.temperature_c === 'number' ? (
          <div className="weather__temp">{Math.round(props.temperature_c)}°</div>
        ) : null}
        <div className="weather__facts">
          {props.summary ? <div>{plain(props.summary)}</div> : null}
          {props.precipitation ? <div>
              <span className="weather__label">Осадки:</span> {plain(props.precipitation)}
            </div> : null}
          {props.wind ? <div>
              <span className="weather__label">Ветер:</span> {plain(props.wind)}
            </div> : null}
        </div>
      </div>
      {props.fountains ? <p className="notice notice--slate">{plain(props.fountains)}</p> : null}
      <CardActions sourceId={props.id} actions={props.actions} />
    </article>
  );
}
